import { render, staticRenderFns } from "./MtSwitch.vue?vue&type=template&id=bfed2e60&scoped=true&"
import script from "./MtSwitch.vue?vue&type=script&lang=js&"
export * from "./MtSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MtSwitch.vue?vue&type=style&index=0&id=bfed2e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfed2e60",
  null
  
)

export default component.exports